import React, { useState, useEffect, useRef } from "react";
import "../styles/BioLinks.css";
import logo from "../imgs/logo-jessica-2.svg";
import videoBg from "../assets/video_web.mp4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faWhatsapp,
  faElementor,
} from "@fortawesome/free-brands-svg-icons";
import { faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import PlanCard from "./PlanCard";
import GoogleReviews from "./GoogleReviews";

import jessicaImg from "../imgs/jessica.png";
import stuidoImg from "../imgs/studio.jpg";
import jpilatesImg from "../imgs/jpilates.png";

const BioLinks = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const addSectionRef = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  return (
    <>
      <div className="video-container">
        <video
          src={videoBg}
          autoPlay
          loop
          muted
          playsInline
          className="video-bg"
        />
        <div className="overlay"></div>
      </div>

      <div className="bio-links-container">
        <header className="header">
          <div className="menu-icon" onClick={toggleMenu}>
            <FontAwesomeIcon icon={faElementor} />
          </div>
          {menuOpen && (
            <nav className="menu">
              <a href="/admin" className="admin-button">
                Área Administrativa
              </a>
            </nav>
          )}
        </header>

        <section className="top-section" ref={addSectionRef}>
          <img src={logo} alt="Logo" className="logo" />
          <p className="highlight">
            Excelência em Pilates Clássico com formação exclusiva
          </p>
          <p className="follow-me">
            Agende sua aula escolhendo um dos planos abaixo!
          </p>
        </section>

        <section className="plans-section" ref={addSectionRef}>
          <h2 className="section-title">Planos</h2>
          <div className="plan-cards-wrapper">
            <PlanCard
              title="Plano Essencial"
              features={[
                "1 Sessão por semana",
                "Atendimento individualizado",
                "Sessão de 1 hora",
              ]}
              cta="Quero fazer Pilates"
              whatsappMessage="Olá, tenho interesse no Plano Essencial (1x por semana)."
            />
            <PlanCard
              title="Plano Plus"
              features={[
                "2 Sessões por semana",
                "Atendimento individualizado",
                "Sessão de 1 hora",
              ]}
              cta="Quero fazer Pilates"
              whatsappMessage="Olá, tenho interesse no Plano Plus (2x por semana)."
            />
            <PlanCard
              title="Plano Premium"
              features={[
                "3 Sessões por semana",
                "Atendimento individualizado",
                "Sessão de 1 hora",
              ]}
              cta="Quero fazer Pilates"
              whatsappMessage="Olá, tenho interesse no Plano Premium (3x por semana)."
            />
          </div>
        </section>

        <section className="bottom-section" ref={addSectionRef}>
          <h2 className="section-title">Conheça o Studio</h2>
          <div className="info-cards">
            <div className="card">
              <img src={jpilatesImg} alt="Pilates" className="card-image" />
              <div className="card-content">
                <h2>O que é Pilates?</h2>
                <p>
                  Um método de exercício que visa fortalecer o corpo, melhorar a
                  flexibilidade, o equilíbrio e a postura.
                </p>
              </div>
            </div>
            <div className="card">
              <img src={stuidoImg} alt="Studio" className="card-image" />
              <div className="card-content">
                <h2>Infraestrutura</h2>
                <p>
                  Ambiente climatizado, moderno e acolhedor, com equipamentos de
                  alta qualidade para seu conforto.
                </p>
              </div>
            </div>
            <div className="card">
              <img
                src={jessicaImg}
                alt="Jéssica Zanardi"
                className="card-image"
              />
              <div className="card-content">
                <h2>Fisioterapeuta</h2>
                <p>
                  Mais de 6 anos de experiência em Pilates Clássico, oferecendo
                  um acompanhamento técnico e personalizado.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="reviews-section" ref={addSectionRef}>
          <h2 className="section-title">O que dizem nossos alunos</h2>
          <GoogleReviews
            rating={5}
            count={6}
            link="https://www.google.com/maps/place/J%C3%A9ssica+Zanardi+Studio+de+Pilates/@-21.7082793,-51.0250197,14.3z/data=!4m8!3m7!1s0x9496a1ca77886397:0x4d3fc6b485b89352!8m2!3d-21.7182428!4d-51.0130388!9m1!1b1!16s%2Fg%2F11y98s512w?entry=ttu"
          />
        </section>

        <footer className="footer" ref={addSectionRef}>
          <p>© 2026 - Todos os direitos reservados.</p>
        </footer>
      </div>

      {/* FABs */}
      <a
        href="https://wa.me/5518997958480?text=Ol%C3%A1,%20tenho%20interesse%20em%20agendar%20uma%20aula."
        className="fab whatsapp-fab"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale Conosco pelo WhatsApp"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
      <a
        href="https://www.instagram.com/jessicanzanardi"
        className="fab instagram-fab"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Siga-nos no Instagram"
      >
        <FontAwesomeIcon icon={faInstagram} />
      </a>

      {/* Bottom Navigation */}
      <a href="/student-area" className="fixed-bottom-btn">
        <FontAwesomeIcon icon={faUserGraduate} />
        <span>Área do Aluno</span>
      </a>
    </>
  );
};

export default BioLinks;
